var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_5440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9333 9.52499C20.9258 9.39769 20.8719 9.27755 20.7817 9.18738C20.6916 9.09721 20.5714 9.04328 20.4441 9.03585C15.4922 8.7451 11.5257 10.2359 9.83455 13.0329C9.24838 13.9897 8.95951 15.099 9.00457 16.2201C9.03399 16.9371 9.17986 17.6445 9.43647 18.3146C9.45155 18.3558 9.47682 18.3926 9.50993 18.4214C9.54304 18.4503 9.58291 18.4703 9.62582 18.4795C9.66874 18.4888 9.71331 18.4871 9.75538 18.4745C9.79745 18.4619 9.83565 18.4389 9.86642 18.4076L15.3953 12.7942C15.4436 12.7458 15.501 12.7075 15.5642 12.6813C15.6274 12.6551 15.6951 12.6417 15.7634 12.6417C15.8318 12.6417 15.8995 12.6551 15.9627 12.6813C16.0259 12.7075 16.0833 12.7458 16.1316 12.7942C16.1799 12.8425 16.2183 12.8999 16.2445 12.9631C16.2706 13.0263 16.2841 13.094 16.2841 13.1623C16.2841 13.2307 16.2706 13.2984 16.2445 13.3616C16.2183 13.4247 16.1799 13.4821 16.1316 13.5305L10.0895 19.6636L9.16654 20.5866C9.07055 20.6801 9.01324 20.8062 9.00601 20.94C8.99878 21.0738 9.04215 21.2054 9.12751 21.3086C9.17425 21.3628 9.23166 21.4067 9.29614 21.4376C9.36061 21.4686 9.43078 21.4859 9.50226 21.4885C9.57373 21.4912 9.64498 21.479 9.71156 21.4529C9.77813 21.4267 9.8386 21.3872 9.88919 21.3366L10.9813 20.2445C11.901 20.6894 12.8292 20.932 13.7496 20.9645C13.8221 20.9671 13.8943 20.9684 13.9662 20.9684C15.0144 20.9711 16.0426 20.6824 16.9362 20.1346C19.7332 18.4434 21.2247 14.4776 20.9333 9.52499Z",
    fill: "#1BF463"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_5440",
    x: 0.0337372,
    y: 0.0337372,
    width: 29.9018,
    height: 30.4214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.48313
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_5440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_5440",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.7beb8ed1cc2b3655ddd640f138a6ad58.svg";
export { ForwardRef as ReactComponent };